"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const classnames_1 = require("classnames");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const ChipTabsStyle_1 = require("./jss/ChipTabsStyle");
const BootstrapInput = (0, styles_1.withStyles)(ChipTabsStyle_1.default)(core_1.InputBase);
class ChipTabs extends React.Component {
    constructor() {
        super(...arguments);
        this.handleChange = (event) => {
            this.props.selectTab(event.target.value);
        };
    }
    render() {
        const { classes, collapsible, tabs, selectedTab, t } = this.props;
        if (!collapsible) {
            return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.tabs }, { children: this.renderTabs() }));
        }
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.tabs, role: "radiogroup" }, { children: [(0, jsx_runtime_1.jsx)(core_1.Hidden, Object.assign({ smDown: true }, { children: this.renderTabs() })), (0, jsx_runtime_1.jsx)(core_1.Hidden, Object.assign({ mdUp: true }, { children: (0, jsx_runtime_1.jsx)(core_1.FormControl, { children: (0, jsx_runtime_1.jsx)(core_1.Select, Object.assign({ value: selectedTab, onChange: this.handleChange, input: (0, jsx_runtime_1.jsx)(BootstrapInput, { name: "po-widget-tab", id: "tab-id" }), classes: { icon: classes.icon } }, { children: tabs.map(tab => ((0, jsx_runtime_1.jsx)(core_1.MenuItem, Object.assign({ value: tab }, { children: t(tab).toUpperCase() }), tab))) })) }) }))] })));
    }
    renderTabs() {
        const { classes, tabs, selectedTab, selectTab, t } = this.props;
        return tabs.map((tab, index) => ((0, jsx_runtime_1.jsx)(core_1.Chip, { label: t(tab), "aria-label": tab, role: "radio", tabIndex: 0, className: (0, classnames_1.default)(classes.tabButton, classes.customLineHeight, { [classes.selected]: tab === selectedTab }, 'po-widget-tab', {
                'po-widget-tab-selected': tab === selectedTab
            }), onClick: selectTab.bind(this, tab), variant: "outlined", "aria-checked": tab === selectedTab ? true : false }, index)));
    }
}
exports.default = (0, styles_1.withStyles)(ChipTabsStyle_1.default)((0, react_i18next_1.withTranslation)()(ChipTabs));
//# sourceMappingURL=ChipTabs.js.map